import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, Suspense } from "react";
import { getOtherOptionsFromWindow } from "../utils";
import { persistConsent, getCookieConsentManager } from "../others";
import { useBlockerProvider, useBlockerStateContextCallbacks, useStateContextCallbacks, Blocker } from "@devowl-wp/react-cookie-banner";
import { Recorder } from "@devowl-wp/web-html-element-interaction-recorder";
import { BannerProductionNotice } from ".";
import { yieldLazyLoad } from "@devowl-wp/react-utils";
const YieldBlocker = yieldLazyLoad(Promise.resolve(Blocker));
/**
 * Simply connects a context store to the blocker itself. On the website itself
 * it should not rely
 */ const WebsiteBlocker = (param)=>{
    let { container, blockedNode, createBefore, poweredLink, blocker, paintMode, setVisualAsLastClickedVisual } = param;
    const { frontend, customizeValuesBanner, iso3166OneAlpha2, bannerDesignVersion, bannerI18n, isPro, isLicensed, isDevLicense, affiliate, isCurrentlyInTranslationEditorPreview } = getOtherOptionsFromWindow();
    const manager = getCookieConsentManager();
    const userDecision = manager.getUserDecision();
    const recorder = useMemo(()=>new Recorder(container), []);
    const modifiers = useStateContextCallbacks();
    const { onUnblock } = useBlockerStateContextCallbacks(manager.getOptions());
    // Context values preparation
    const [BlockerContextProvider, blockerContextValue] = useBlockerProvider({
        recorder,
        container,
        blockedNode,
        createBefore,
        ...customizeValuesBanner,
        ...frontend,
        productionNotice: /*#__PURE__*/ _jsx(BannerProductionNotice, {
            isPro: isPro,
            isLicensed: isLicensed,
            isDevLicense: isDevLicense,
            i18n: bannerI18n
        }),
        paintMode,
        poweredLink,
        iso3166OneAlpha2,
        gcmConsent: [],
        blocker,
        designVersion: bannerDesignVersion,
        i18n: bannerI18n,
        keepVariablesInTexts: isCurrentlyInTranslationEditorPreview,
        affiliate,
        consent: {
            ...userDecision === false ? {} : userDecision.consent
        },
        onPersistConsent: persistConsent,
        onApplyConsent: ()=>getCookieConsentManager().applyCookies({
                type: "consent"
            })
    }, {
        ...modifiers,
        onUnblock: (contextValue, event)=>{
            onUnblock(contextValue, event);
            setVisualAsLastClickedVisual(event);
        }
    });
    return /*#__PURE__*/ _jsx(BlockerContextProvider, {
        value: blockerContextValue,
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(YieldBlocker, {})
        })
    });
};
export { WebsiteBlocker };
